export default __webpack_public_path__ + "static/imgSSM4-218af5feeda4102a381a1062d7e0739a.png";